module.exports = __webpack_public_path__ + "media/brand/scribble-green-38f47c59.svg";